import { render, staticRenderFns } from "./vEditor.vue?vue&type=template&id=2fa620aa&scoped=true"
import script from "./vEditor.vue?vue&type=script&lang=js"
export * from "./vEditor.vue?vue&type=script&lang=js"
import style0 from "./vEditor.vue?vue&type=style&index=0&id=2fa620aa&prod&lang=css"
import style1 from "./vEditor.vue?vue&type=style&index=1&id=2fa620aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa620aa",
  null
  
)

export default component.exports